import React, { FC } from 'react';

import {
    FlexColumn,
    FlexRow,
    H3,
    PageBody,
    PageBodyFooter,
    PageContainer,
    PageTile,
    PageTileBody,
    PageTileHeader,
} from '@portal/common/components';
import { styled } from '@portal/common/theme';

import _ from '../../locale';
import DataExplorerWidget from './DataExplorerWidget';
import LicenseWarningTile from './LicenseWarningTile';
import News from './News';
import TabbedView from './TabbedView';
import WelcomeTile from './WelcomeTile';

const Container = styled(FlexRow)(({ theme }) => ({
    flexGrow: 1,
    flexWrap: 'wrap',

    [theme.breakpoint.md]: {
        flexWrap: 'unset',
    },
}));

const Column1 = styled(FlexColumn)(({ theme }) => ({
    marginTop: -15,
    minWidth: 550,
    flexBasis: 550,
    flexGrow: 1,
    flexShrink: 1,
    '> :not(:last-child)': {
        marginBottom: 15,
    },

    [theme.breakpoint.md]: {
        marginTop: 0,
        '> :not(:last-child)': {
            marginBottom: 30,
        },
    },

    [theme.breakpoint.lg]: {
        flexGrow: 4,
        flexShrink: 4,
    },
}));

const Column2 = styled(FlexColumn)(({ theme }) => ({
    marginTop: 15,
    marginLeft: 0,
    minWidth: 250,
    maxWidth: '100%',
    flexBasis: '340px',
    flexGrow: 1,
    flexShrink: 1,
    '> :not(:last-child)': {
        marginBottom: 15,
    },

    [theme.breakpoint.md]: {
        flexGrow: 0,
        flexShrink: 0,
        marginTop: 0,
        marginLeft: 30,
        maxWidth: 550,
        '> :not(:last-child)': {
            marginBottom: 30,
        },
    },
    [theme.breakpoint.lg]: {
        flexGrow: 1,
        flexShrink: 1,
    },
}));

const HomeScene: FC = () => (
    <PageContainer>
        <PageBody transparentSurface noHeader>
            <Container>
                <Column1>
                    <LicenseWarningTile />
                    <WelcomeTile />
                    <PageTile style={{ padding: 30 }}>
                        <TabbedView />
                    </PageTile>
                </Column1>
                <Column2>
                    <PageTile>
                        <PageTileBody>
                            <PageTileHeader>
                                <H3>{_('exlore_data_section_header')}</H3>
                            </PageTileHeader>
                            <DataExplorerWidget />
                        </PageTileBody>
                    </PageTile>
                    <PageTile>
                        <PageTileBody>
                            <PageTileHeader>
                                <H3>{_('news_and_announcements_section_header')}</H3>
                            </PageTileHeader>
                            <News />
                        </PageTileBody>
                    </PageTile>
                </Column2>
            </Container>
            <PageBodyFooter>{_.get('footer_note')}</PageBodyFooter>
        </PageBody>
    </PageContainer>
);

export default HomeScene;
